export function hasClass(el, str) {
  return el.className.indexOf(str) >= 0;
}